<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>{{$t('clientsPage.physicsForms.titleNew')}}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>
    <span @click="$router.go(-1)" class="goback">{{$t('clientsPage.physicsForms.gotoBack')}}</span>

    <v-layout>
      <v-flex xs12>
        <client-physics-form></client-physics-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ClientPhysicsForm from "@/components/clients/physics_form";

export default {
  name: "AddPhysics",
  components: { ClientPhysicsForm },
  data: () => ({}),
  methods: {},
};
</script>
